import { render, staticRenderFns } from "./TecnicalSupportFilter.vue?vue&type=template&id=0a0d23e6"
import script from "./TecnicalSupportFilter.vue?vue&type=script&lang=js"
export * from "./TecnicalSupportFilter.vue?vue&type=script&lang=js"
import style0 from "./TecnicalSupportFilter.vue?vue&type=style&index=0&id=0a0d23e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports